(function(){
  function initGallery(gallery){
    if(!gallery) return;
    var sectionId = gallery.getAttribute('data-id') || '';
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.featured-product-slider .swiper-slide, .featured-product-slider .product-model-element'));
    var thumbs = document.querySelector('[data-saptour-thumbs="' + sectionId + '"]');
    var buttons = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll('[data-saptour-thumb-index]')) : [];
    if(!slides.length || !buttons.length) return;

    function show(index){
      index = parseInt(index, 10);
      if(isNaN(index) || index < 0 || index >= slides.length) index = 0;
      slides.forEach(function(slide,i){
        var active = i === index;
        slide.classList.toggle('is-saptour-active', active);
        slide.classList.toggle('swiper-slide-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      buttons.forEach(function(btn){
        var btnIndex = parseInt(btn.getAttribute('data-saptour-thumb-index'), 10);
        var active = btnIndex === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    buttons.forEach(function(btn){
      if(btn.dataset.saptourThumbBound === '1') return;
      btn.dataset.saptourThumbBound = '1';
      btn.addEventListener('click', function(event){
        event.preventDefault();
        show(btn.getAttribute('data-saptour-thumb-index'));
      });
    });

    var activeIndex = slides.findIndex(function(slide){ return slide.classList.contains('swiper-slide-active'); });
    show(activeIndex >= 0 ? activeIndex : 0);
  }
  function boot(){ Array.prototype.slice.call(document.querySelectorAll('product-gallery-media.main-product-media-wrapper')).forEach(initGallery); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();